var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.656,
    height: 5.657,
    viewBox: "0 0 19.656 5.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.656,
    height: 5.657,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8562.828 -2448.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5668",
    "data-name": "Group 5668",
    transform: "translate(-8203 815) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1636 340.172) rotate(45)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1636 347.172) rotate(45)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1636 354.172) rotate(45)",
    fill: "#e23744"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menuDots.5679fb497bef54e29a3fb49071dd47b2.svg";
export { ForwardRef as ReactComponent };